import React from 'react';
import DocEditor from '../../elements/editors/DocEditor';
import TagsEditor from '../../elements/tags/TagsEditor';
import TagsView from '../../elements/tags/TagsView';
import RelatedFlowsCard from './RelatedFlowsCard';
import * as resourceTypes from '../../../constants/resourceTypes';
import DateUtils from '../../../lib/DateUtils';
import { ReactComponent as CalendarIcon } from 'new/components/icons/calendar.svg';
import { ReactComponent as ClockIcon } from 'new/components/icons/fi-rr-clock.svg';
import styles from './ProjectOverview.module.scss';

class ProjectOverview extends React.Component {
  componentDidMount() {
    this.props.getProjectDoc(this.props.data.id);
  }

  render() {
    const { data, doc, isLoading, updateProjectDoc, readOnly } = this.props;

    const createdDate = data?.created_at
      ? DateUtils.convertDateStringToFormat(data.created_at)
      : null;

    const updatedDate = data?.updated_at
      ? DateUtils.convertDateStringToFormat(data.updated_at)
      : null;

    const tagsView =
      readOnly === true ? (
        <TagsView data={data} />
      ) : (
        <TagsEditor id={data.id} resourceType={resourceTypes.RESOURCE_TYPE_PROJECTS} />
      );

    return (
      <div className={`tab-content ${styles.tabContent}`}>
        <div className={styles.container}>
          <div className={styles.leftColumn}>
            <DocEditor
              data={data}
              doc={doc}
              isLoading={isLoading.doc}
              updateDoc={updateProjectDoc}
            />
          </div>

          <div className={styles.rightColumn}>
            {createdDate && (
              <section className={styles.sidebarSection}>
                <div className={styles.sidebarHeader}>
                  <CalendarIcon className={styles.sidebarIcon} />
                  CREATED ON
                </div>
                <div className={styles.sidebarValue}>{createdDate}</div>
              </section>
            )}

            {updatedDate && (
              <section className={styles.sidebarSection}>
                <div className={styles.sidebarHeader}>
                  <ClockIcon className={styles.sidebarIcon} />
                  LAST UPDATED
                </div>
                <div className={styles.sidebarValue}>{updatedDate}</div>
              </section>
            )}

            <RelatedFlowsCard projectId={data?.id} flowsCount={data?.flows_count || 0} />

            <section className={styles.sidebarSection}>
              <h3 className={styles.tagsTitle}>TAGS</h3>
              {tagsView}
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectOverview;
